(() => {
  function initGallery(root) {
    if (root.dataset.galleryReady) return;
    const main = root.querySelector('.product-main-image');
    const thumbs = [...root.querySelectorAll('[data-kb-gallery-thumb]')];
    if (!main || !thumbs.length) return;
    root.dataset.galleryReady = 'true';
    let active = Math.max(0, thumbs.findIndex(thumb => thumb.getAttribute('aria-pressed') === 'true'));
    const status = root.querySelector('[data-kb-gallery-status]');
    const layout = root.closest('.product-layout');
    const select = layout.querySelector('[data-kb-variants]');
    const json = layout.querySelector('[data-kb-variant-json]');
    let variants = json ? JSON.parse(json.textContent) : [];
    const normalize = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase().replace(/[^a-z0-9]+/g,' ').trim();
    function matchesPhoto(variant, thumb) {
      const options = variant.options || [];
      const colorFinish = normalize([options[0],variant.finish || options[1]].join(' '));
      const alt = normalize(thumb.dataset.imageAlt);
      // New quantity variants may have no image assignment after a CSV import.
      // Match the descriptive photo label before falling back to Shopify image IDs.
      if (options[0] && options[1] && alt.startsWith('kunststof kerstbal 8 cm ')) {
        return alt === 'kunststof kerstbal 8 cm ' + colorFinish;
      }
      if (options[0] && variant.finish && alt.startsWith('glazen kerstbal 8 cm ')) {
        return alt === 'glazen kerstbal 8 cm ' + normalize([variant.finish,options[0]].join(' '));
      }
      return String(variant.image_id) === thumb.dataset.imageId;
    }
    function selectPhoto(index) {
      const position = (index + thumbs.length) % thumbs.length;
      const matches = variants.filter(variant => matchesPhoto(variant, thumbs[position]));
      // Keep an existing matching choice when several variants share a photo.
      const selected = variants.find(item => select && String(item.id) === select.value);
      const variant = matches.find(item => select && String(item.id) === select.value)
        || matches.slice().sort((a,b) => { const score = item => (item.options || []).reduce((sum,value,i) => sum + (i > 0 && value === selected?.options?.[i] ? (i === 2 ? 10 : 2) : 0),0); return score(b)-score(a); })[0]
        || matches.find(item => item.available) || matches[0];
      if (select && variant && select.value !== String(variant.id)) {
        select.value = String(variant.id);
        // Reuse the product form's price and availability update.
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
      show(position);
    }
    function show(index, reveal = true) {
      active = (index + thumbs.length) % thumbs.length;
      const thumb = thumbs[active];
      // Set srcset too, otherwise the browser could keep displaying the previous color.
      main.srcset = thumb.dataset.fullSrcset;
      main.src = thumb.dataset.fullSrc;
      main.alt = thumb.dataset.imageAlt;
      main.width = Number(thumb.dataset.imageWidth);
      main.height = Number(thumb.dataset.imageHeight);
      thumbs.forEach((button, position) => button.setAttribute('aria-pressed', String(position === active)));
      status.textContent = (active + 1) + ' / ' + thumbs.length + ' — ' + thumb.dataset.imageAlt;
      if (reveal) {
        const strip = root.querySelector('[data-kb-gallery-thumbnails]');
        const left = thumb.offsetLeft;
        if (left < strip.scrollLeft) strip.scrollLeft = left;
        else if (left + thumb.offsetWidth > strip.scrollLeft + strip.clientWidth) {
          strip.scrollLeft = left + thumb.offsetWidth - strip.clientWidth;
        }
      }
    }
    thumbs.forEach((thumb, index) => {
      thumb.addEventListener('click', () => selectPhoto(index));
      thumb.addEventListener('keydown', event => {
        let next;
        if (event.key === 'ArrowRight') next = (index + 1) % thumbs.length;
        else if (event.key === 'ArrowLeft') next = (index + thumbs.length - 1) % thumbs.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = thumbs.length - 1;
        else return;
        event.preventDefault(); selectPhoto(next); thumbs[next].focus({ preventScroll: true });
      });
    });
    root.querySelector('[data-kb-gallery-prev]').addEventListener('click', () => selectPhoto(active - 1));
    root.querySelector('[data-kb-gallery-next]').addEventListener('click', () => selectPhoto(active + 1));
    layout.addEventListener('kb:variants-ready', () => { variants = JSON.parse(json.textContent); });
    if (select && json) {
      select.addEventListener('change', () => {
        const variant = variants.find(item => String(item.id) === select.value);
        if (!variant) return;
        const index = thumbs.findIndex(thumb => matchesPhoto(variant, thumb));
        // Variants without their own photo fall back to the first product photo.
        show(index < 0 ? 0 : index);
      });
    }
    root.querySelectorAll('[data-kb-gallery-controls], [data-kb-gallery-thumbnails]').forEach(element => { element.hidden = false; });
    const initialVariant = variants.find(item => select && String(item.id) === select.value);
    const initialPhoto = initialVariant ? thumbs.findIndex(thumb => matchesPhoto(initialVariant, thumb)) : -1;
    show(initialPhoto >= 0 ? initialPhoto : active, false);
  }
  function boot() { document.querySelectorAll('[data-kb-gallery]').forEach(initGallery); }
  boot();
  document.addEventListener('shopify:section:load', boot);
})();
